import { postReq } from 'src/services/http';
import { profile_data } from 'src/stores/account/user';
import { deleteProfileField, upsertProfileField } from './profile_data_helpers';

export const save_profile = async (id: string, data: unknown) => {
	const res = await postReq('interface/profile/save', {
		data: JSON.stringify(data),
		id,
	});

	if (res?.isok) {
		profile_data.update((currentProfile) => upsertProfileField(currentProfile, id, data));
	} else {
		console.error(`Failed to save profile field "${id}".`);
	}

	return res;
};

export const delete_profile = async (id: string) => {
	const res = await postReq('interface/profile/delete', { id });

	if (res?.isok) {
		profile_data.update((currentProfile) => deleteProfileField(currentProfile, id));
	} else {
		console.error(`Failed to delete profile field "${id}".`);
	}

	return res;
};
